module.exports = __webpack_public_path__ + "media/packs/landing_page/images/studios/icycle-0adcbadc83a0754d165db2ab789d8207.png";